import type {TagType} from 'nutshell-graphql-types';

const TAG_TYPE_LABELS: Record<TagType, string> = {
    LEAD: 'Lead',
    CONTACT: 'Person',
    ACCOUNT: 'Company',
};

export function getTagOptionLabel(
    tagName: string,
    tagType: TagType,
    shouldIncludeTagType: boolean
): string {
    if (!shouldIncludeTagType) {
        return tagName;
    }

    return `${tagName} (${TAG_TYPE_LABELS[tagType]})`;
}
